import { Helmet } from "react-helmet-async";

/**
 * Helmet block for HardRedirect — emits the meta tags lovablehtml's prerender
 * needs to detect a real redirect (vs. an SPA route swap that sometimes mis-
 * resolves to a self-loop or destination-content-under-source-URL).
 *
 * - <meta http-equiv="refresh" content="0;url=…"> is the canonical no-JS
 *   redirect signal. lovablehtml's prerender pipeline statically detects this
 *   and emits a real 301 Moved Permanently for crawlers, while real browsers
 *   honor it natively too.
 * - <meta name="robots" content="noindex, follow"> tells search engines: do
 *   not index this URL, but follow the link. In case the prerender DOES end
 *   up serving content here, it's flagged out of the index immediately.
 * - <link rel="canonical"> points to the destination so any equity bleeds
 *   into the right page.
 */
export default function HardRedirectHead({ to }: { to: string }) {
  const absoluteTo = to.startsWith("http") ? to : `https://www.bodyhackguide.co${to}`;
  return (
    <Helmet>
      <title>Redirecting…</title>
      <meta httpEquiv="refresh" content={`0;url=${to}`} />
      <meta name="robots" content="noindex, follow" />
      <link rel="canonical" href={absoluteTo} />
    </Helmet>
  );
}
